import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { About } from '../about/about';
import { Customer } from '../customer/customer';
import { Partners } from '../partners/partners';
import { Rider } from '../rider/rider';
import { Erp } from '../erp/erp';
import { Screens } from '../screens/screens';
import { Features } from '../features/features';
import { Faq } from '../faq/faq';
import { Contact } from '../contact/contact';

@Component({
  selector: 'app-home',
  imports: [About, Customer, Partners, Rider, Erp, Screens, Features, Faq, Contact],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  protected readonly customerUrl = environment.customerUrl;
  protected readonly partnerUrl = environment.partnerUrl;
  protected readonly riderUrl = environment.riderUrl;
}
